export default function OptionalLabel() {
  return (
    <span className="inline-block rounded bg-slate-950 px-2 py-0.5 font-semibold text-cyan-200 ring-1 ring-cyan-300/60">
      (Optional)
    </span>
  );
}
